import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { Region } from "@/gql/graphql";
import { useTranslations } from "use-intl";

export function RegionInput(props: Omit<SelectInputProps<any>, "options">) {
  const t = useTranslations("city");

  const sections = [
    {
      label: "Oceania",
      regions: [Region.Au, Region.Nz, Region.Pi],
    },
    {
      label: "North America",
      regions: [Region.Ca, Region.Us, Region.Mx],
    },
    {
      label: "South America",
      regions: [Region.Sa],
    },
    {
      label: "Europe",
      regions: [Region.Eu],
    },
    {
      label: "Asia",
      regions: [Region.Jp, Region.Kr, Region.Tw],
    },
    {
      label: "Middle East",
      regions: [Region.Me],
    },
    {
      label: "Africa",
      regions: [Region.Sacu],
    },
  ];

  const options = sections.map((section) => ({
    label: section.label,
    options: section.regions.map((region) => ({
      label: t(`region.${region}`),
      value: region,
    })),
  }));

  return (
    <SelectInput
      options={options}
      filter={(value, search) => {
        const label: string = t(`region.${value as Region}`);
        return label.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
      }}
      {...props}
    />
  );
}
